<script>
import InvoiceDesktopView from "./InvoiceDesktopView.vue";

/**
 * Desktop layout bridge.
 * Renders InvoiceDesktopView using the parent invoice instance as context
 * so template bindings and $refs stay on index.vue (provide/inject).
 */
export default {
  name: "InvoiceDesktopBridge",
  inject: ["invoice"],
  render() {
    const invoice = this.invoice;
    const viewOptions = InvoiceDesktopView.options || InvoiceDesktopView;
    const render = viewOptions.render;

    if (!invoice || typeof render !== "function") {
        return null;
      }

    const options = invoice.$options;
    const prevStaticRenderFns = options.staticRenderFns;
    const prevScopeId = options._scopeId;

    options.staticRenderFns = viewOptions.staticRenderFns;
    if (viewOptions._scopeId) {
      options._scopeId = viewOptions._scopeId;
    }

    try {
      return render.call(invoice, invoice.$createElement);
    } finally {
      options.staticRenderFns = prevStaticRenderFns;
      options._scopeId = prevScopeId;
    }
  },
};
</script>
